// functions / libraries
import React from 'react';
import { __, __n } from 'i18n-for-browser';
import Defines from '../../Defines';
import connect from "react-redux/es/connect/connect";


import {
  getFeedback,
  getFeedbackTitle,
  getSubtitle,
  getIcon,
  getCosts,
  getCollaborations,
  getPoints,
  getImageText,
  getImage,
  checkIfCollab,
  getText,
  getSideEffects,
  checkRead,
  unreadCount,
  getPolicyChoiceFeedback,
  getPolicyChoiceTotalPoints,
} from "../../helpers/feedbackHelpers";
import history from "../../history.js";
import { getTitle, getOplossingTitle, getIcon as getPolicyChoiceIcon, getOplossingTekst, getProbleemTekst } from "../../helpers/policyChoiceHelper";
import {getGroupIcons} from '../../helpers/groupHelper';
import actions from '../../actions';

// components
import ScoreRow from '../elements/ScoreRow';
import ListButton from '../elements/ListButton';
import ScoreHistory from '../elements/ScoreHistory';
import FeedbackImage from '../elements/feedback/FeedbackImage';
import FeedbackHeader from '../elements/feedback/FeedbackHeader';
import FeedbackEffect from '../elements/feedback/FeedbackEffect';
import DifficultyAwareComponent from "../DifficultyAwareComponent";

// assets
import ContentContainer from "../elements/ContentContainer";
import {ministryIcons, icons} from '../../assets/assets.js';
import FeedbackStatusRounds from "../elements/feedback/FeedbackStatusRounds";
import UpGlobas from '../../assets/img/icons/economy/up-globas.svg';
import MinGlobas from '../../assets/img/icons/economy/min-globas.svg';
import BeleidskeuzeL from "../../assets/img/icons/beleidskeuze_L.svg";
import CaretDown from "../../assets/img/caret_down_grey.svg";
import GameTopBar from "../elements/GameTopBar";
import {Link} from "react-router-dom";

const { updateRead } = actions.feedback;

class Feedback extends DifficultyAwareComponent {
  constructor(props) {
    super(props);
    this.pageType = props.match.params.id;
    this.feedbackId = props.match.params.feedbackIdentifier;
    this.effectId = props.match.params.effect;
    this.oe = this.pageType === 'overigEffect';
    this.economie = this.pageType === 'economie';
    this.state = {
      flip: true,
      showProbleemOplossing: false,
    };
  }

  flipContainer = () => {
    this.setState(prevState => ({
      flip: !prevState.flip,
    }));
  };

  toggleProbleemOplossing = () => {
    this.setState(prevState => ({
      showProbleemOplossing: !prevState.showProbleemOplossing,
    }));
  };

  renderMinistryHeader = (feedback, overigEffect, economie) => {
    const { gameState, feedback: feedbacks } = this.props;
    if (this.pageType === 'beleidskeuze' && gameState.difficulty === 'BASIC') {
      return [<ListButton
                key={'cat'}
                bgColor='darkblue'
                title={__n('sim_beleidskeuze', 0)}
                icon={BeleidskeuzeL}
                className={"beleidskeuze-listbutton-laag"}
                feedbackCount={unreadCount(getPolicyChoiceFeedback(feedback.prevRoundFeedbackData), null, true)}
                arrow={true}
                points={getPolicyChoiceTotalPoints(feedbacks.prevRoundFeedbackData)}
                onClick={() => { this.props.history.goBack(); }}
                globas={undefined}
              />,
              <ListButton
                key={'pol'}
                bgColor={feedback.kleur_balk}
                title={getOplossingTitle(feedback, this.props.gameState.language)}
                arrow={true}
                policy={true}
                feedback={true}
                icon={getPolicyChoiceIcon(feedback)}
                points={feedback.puntenscore}
              />
            ]
    }
    let ministerie = feedback.ministerie;
    // Check if economie
    if (this.economie) {
      const { prevRoundSum } = gameState;
      if(!prevRoundSum) return null;
      const { OneTimeEffect } = prevRoundSum;
      const type = parseInt(economie.winstverliesglobas, 10) >= 0 ? 'profit' : 'loss';
      const unreadFeedback = [];
      return <ListButton
                bgColor='blue'
                title={(type === 'profit' ? __('sim_winstglobas') : __('sim_verliesglobas'))}
                icon={(type === 'profit' ? UpGlobas : MinGlobas)}
                feedbackCount={unreadFeedback.length}
                arrow={true}
                isGlobas={true}
                points={(type === 'profit' ? '+' + OneTimeEffect.WG : '-' + (-OneTimeEffect.VG))}
                popupId={(type === 'profit' ? 'mhgvtwinstglobas' : 'mhgvtverliesglobas')}
              />;
    }
    // Check if OE
    if (this.oe) {
      ministerie = overigEffect.ministerie;
    }
    if (feedback && feedback.type !== 'BELASTING') {
      return <ListButton
                key="minHeader"
                ministry={ministerie}
                title={__(ministerie)}
                icon={ministryIcons[ministerie]}
                arrow={true}
                stars={Defines.ministeryStars[ministerie]}
                points={gameState.prevRoundSum ? String(gameState.prevRoundSum[`${ministerie}_points`]) : '0'}
                popupId={gameState.difficulty === 'BASIC' ? Defines.ministryPopupIds.basic[ministerie] : Defines.ministryPopupIds.pro[ministerie]}
                global={Defines.i18nMinistries.includes(ministerie)}
              />;
    }
    return null;
  }

  renderFeedbackHeader = (feedback, overigEffect, economie) => {
    const { gameState, history } = this.props;
    if (this.pageType === 'beleidskeuze' && gameState.difficulty === 'BASIC') {
      let title;
      if (feedback.oplossing_code) {
        title = getOplossingTitle(feedback, gameState.language);
      } else {
        title = getTitle(feedback, gameState.language);
      }

      return <ListButton
                className="policy-choice-laag"
                read={checkRead(feedback)}
                bgColor={(Math.sign(feedback.puntenscore) ? 'green' : 'red')}
                title={title}
                arrow={true}
                feedback={true}
                thumbnail={getPolicyChoiceIcon(feedback)}
                points={feedback.puntenscore}
              />
    }
    if (feedback) {
    return <FeedbackHeader
              key="header"
              currentRound={gameState.currentRound}
              history={history}
              type={getFeedbackTitle(feedback)}
              subtitle={getSubtitle(feedback, gameState.language)}
              icon={getIcon(feedback)}
              disaster={feedback.type === 'RAMP'}
            />;
    }
    return null;
  }

  renderStatistics = (feedback, overigEffect, economie) => {
    const { gameState, gameStateInput, schoolClass } = this.props;
    if (this.pageType === 'beleidskeuze' && gameState.difficulty === 'BASIC') {
      return (
        <ContentContainer className="problem-solution-container">
          <div className="top-bar" onClick={this.toggleProbleemOplossing}>
            <h3>{__('sim_bekijk_probleem_en_oplossing')}</h3>
            <img src={CaretDown} alt={'close'} className={'close-status' + (this.state.showProbleemOplossing ? ' rotate' : '')}/>
          </div>
          <div className={`inner${(this.state.showProbleemOplossing ? ' show' : '')}`}>
            <div className="inner-content">
              <h4>{__('sim_probleem')}</h4>
              <p>{getProbleemTekst(feedback, gameState.language)}</p>
            </div>
            <div className="inner-content">
              <h4>{__('sim_oplossing')}</h4>
              <p>{getOplossingTekst(feedback, gameState.language)}</p>
            </div>
            <div className="inner-content">
              <h4>{__('sim_kosten')}:</h4>
              <span>{`${feedback.kosten_globas || 0} ${__('sim_miljard')}`}</span>
            </div>
          </div>
        </ContentContainer>
      );
    }
    // check if OE
    if (this.oe) {
      return (
        <div key="card" className="card-container">
          <ContentContainer>
            <ScoreRow
              text={__n('sim_score', 1)}
              score={`${overigEffect.puntenscore} ${__('sim_punten').toLowerCase()}`}
            />
          </ContentContainer>
        </div>
      );
    }
    // check if economie
    if (this.economie) {
      return (
        <div key="card" className="card-container">
          <ContentContainer>
            <ScoreRow
              text={parseInt(economie.winstverliesglobas, 10) >= 0 ? __('sim_winstglobas') : __('sim_verliesglobas')}
              score={`${economie.winstverliesglobas} ${__('sim_miljard')}`}
            />
          </ContentContainer>
        </div>
      );
    }
    if (feedback) {
      if (feedback.type === 'STARTSITUATIE') return null;
      if (['ALGEMEEN', 'RAMP'].indexOf(feedback.type) !== -1) {
        const groupIcons = getGroupIcons(getCollaborations(feedback, gameStateInput), schoolClass.Groups);
        return (
          <div className={"flip-container " + (this.state.flip ? '' : 'flip')}>
              <div className="flipper">
                <div className={`front round-${gameState.Rounds.length - 1}`}>
                  <ScoreRow
                    text={__('sim_kosten')}
                    score={`${getCosts(feedback, gameState)} ${__('sim_miljard')}`}
                  />
                  {Defines.i18nMinistries.includes(feedback.ministerie) ? (
                    groupIcons.length ? (
                      <ScoreRow
                        className="align-right"
                        text={__('sim_samenwerking')}
                        imgs={groupIcons}
                      />
                    ) : (
                      <ScoreRow
                        className="no-collaborations"
                        text={__('sim_samenwerking')}
                        score="-"
                      />
                    )
                  ) : null}
                  <ScoreRow
                    text={__n('sim_score', 1)}
                    score={`${getPoints(feedback, gameState, getCollaborations(feedback, gameStateInput).length)} ${__('sim_punten').toLowerCase()}`}
                  />
                  {gameState.difficulty === "PRO" ?
                    <ScoreRow
                      text={__('sim_neveneffecten')}
                      score={feedback.nevenEffecten || 0}
                    />
                      :
                    null
                  }
                  <button onClick={this.flipContainer}><span>{__('sim_bekijkhistorie')}</span></button>
                </div>
                <div className={`back round-${gameState.Rounds.length - 1}`}>
                  {gameState.Rounds.map((r,i) => <ScoreHistory key={i} round={i} ministerie={feedback.ministerie}/>)}
                  <button onClick={this.flipContainer}><span>{__('sim_terug')}</span></button>
                </div>
              </div>
            </div>
        );
      }
      return (
        <div key="card" className="card-container">
          <ContentContainer>
            <ScoreRow
              text={__('sim_kosten')}
              score={`${getCosts(feedback, gameState)} ${__('sim_miljard')}`}
            />
            {feedback.type === 'BELEIDSKEUZE' && checkIfCollab(feedback) && feedback.omschrijving.match(/SW(\d){1,2}$/i) ? (
              <ScoreRow
                className="align-right"
                text={__('sim_samenwerking')}
                imgs={getGroupIcons(getCollaborations(feedback, gameStateInput), schoolClass.Groups)}
              />
            ) : null}
            <ScoreRow
              text={__n('sim_score', 1)}
              score={`${getPoints(feedback, gameState, getCollaborations(feedback, gameStateInput).length)} ${__('sim_punten').toLowerCase()}`}
            />
            <ScoreRow
              text={__('sim_neveneffecten')}
              score={feedback.nevenEffecten || 0}
            />
          </ContentContainer>
        </div>
      );
    }
    return null;
  }

  renderFeedbackImage = (feedback, overigEffect, economie, forceEconomy = false) => {
    const { gameState } = this.props;
    let text = getImageText(feedback, gameState.language);
    let img = getImage(feedback);
    if (this.oe) {
      text = getImageText(overigEffect, gameState.language);
      img = getImage(overigEffect, feedback);
    }

    if(feedback.niveau.toLowerCase() === 'basic'){
      if (this.economie || forceEconomy) {
        if (feedback.type === 'BELEIDSKEUZE') {
          text = getImageText(feedback.economie, gameState.language);
          img = getImage(feedback.economie);
        } else {
          text = getImageText(economie, gameState.language);
          img = getImage(economie);
        }
      } else if (feedback.type === 'BELEIDSKEUZE') {
        img = feedback.img_2;
      }
    } else {
      if(this.economie && economie) {
        text = getImageText(economie, gameState.language);
        img = getImage(economie, feedback);
      }
    }

    return <FeedbackImage
            disaster={feedback.type === 'RAMP'}
            description={text}
            image={img}
          />
  }

  renderFeedbackText = (feedback, overigEffect, economie) => {
    const { gameState } = this.props;
    let text = getText(feedback, gameState.language);
    if (this.oe) {
      text = getText(overigEffect, gameState.language)
    }
    if (this.economie) {
      text = getText(economie, gameState.language)
    }
    return <ContentContainer>
            <div dangerouslySetInnerHTML={{ __html: text }}/>
          </ContentContainer>;
  }

  renderHoog() {
    const { match, gameState, feedback: {prevRoundFeedbackData} } = this.props;
    const feedback = getFeedback(prevRoundFeedbackData, this.feedbackId);

    if(Object.entries(feedback).length === 0 && feedback.constructor === Object) {
      let url = "/ministries/" + (match.params.ministryId !== undefined ? match.params.ministryId : match.params.id);
      history.push(url);
      return null;
    }

    const overigEffect = feedback.overigeEffecten[this.effectId] || {};
    const economie = feedback.economie || {};
    if (!economie) this.economie = false;
    if (!overigEffect) this.oe = false;
    // Check if OE
    if (this.oe || this.economie) feedback.type = 'OVERIGEFFECT'; // override type with OE
    if(!checkRead(feedback, this.oe, this.effectId, this.economie)) {
      if (this.oe) {
        feedback.read['readOe_' + this.effectId] = true;

        const array = feedback.read;

        array['readOe_' + this.effectId] = true;

        this.props.dispatch(updateRead(feedback.id, array));
      } else if (this.economie) {
        feedback.read.economie = true;

        const array = feedback.read;

        array.economie = true;

        this.props.dispatch(updateRead(feedback.id, array));
      } else {
        feedback.read.read = true;

        const array = feedback.read;

        this.props.dispatch(updateRead(feedback.id, array));
      }
    }

    return (
      <div>
        <div key="fbWrapper" className='container feedbackcontainer'>
          {this.renderMinistryHeader(feedback, overigEffect, economie)}
          {this.renderFeedbackHeader(feedback, overigEffect, economie)}
          {this.renderStatistics(feedback, overigEffect, economie)}
          {['ALGEMEEN', 'RAMP', 'STARTSITUATIE'].indexOf(feedback.type) !== -1 ? <FeedbackStatusRounds ministry={feedback.ministerie}/> : null}
          {this.renderFeedbackImage(feedback, overigEffect, economie)}
          {this.renderFeedbackText(feedback, overigEffect, economie)}
          {feedback.nevenEffecten && !this.oe && !this.economie ? (
            <div className={'effects-container'}>
              <div key="effectsHeader" className={'effects-header'}>
                {feedback.type === 'BELEIDSKEUZE' ? __('sim_beleidskeuze_heeft_effect_op') : __('sim_budgetkeuze_heeft_effect_op')}:
              </div>
              {/* Print OE */}
              {getSideEffects(feedback).map((oe, i) => {
                return (
                  <FeedbackEffect
                    key={i}
                    image={getImage(oe)}
                    // minimal={minimal}
                    ministry={__(oe.ministerie)}
                    ministryIcon={ministryIcons[oe.ministerie]}
                    description={getImageText(oe, gameState.language)}s
                    unit={__('sim_punten').toLowerCase()}
                    points={getPoints(oe, gameState)}>
                    <div dangerouslySetInnerHTML={{ __html: getText(oe, gameState.language) }}/>
                  </FeedbackEffect>
                );
              })}
              {/* Print Economie */}
              {feedback.economie ? (
                <FeedbackEffect
                  image={getImage(feedback.economie)}
                  ministry={__('sim_economie')}
                  pointsTitle={`${Math.abs(feedback.economie.winstverliesglobas)} ${__('sim_miljard')} ${parseInt(feedback.economie.winstverliesglobas, 10) >= 0 ? __('sim_winstglobas') : __('sim_verliesglobas')}`}
                  ministryIcon={parseInt(feedback.economie.winstverliesglobas, 10) >= 0 ? icons.upGlobas : icons.minGlobas}
                  description={getImageText(feedback.economie, gameState.language)}
                  unit={__('sim_globas')}
                  points={feedback.economie.winstverliesglobas}>
                  <div dangerouslySetInnerHTML={{ __html: getText(feedback.economie, gameState.language) }}/>
                </FeedbackEffect>
              ) : null}
              {/* Print OI */}
              {feedback.overigeInkomsten ? (
                <FeedbackEffect
                  ministry={__('sim_overige_inkomsten')}
                  ministryIcon={icons.gift}
                  pointsTitle={`${feedback.overigeInkomsten.winstverliesglobas} ${__('sim_miljard')} ${__('sim_globas')}`}
                  description={getImageText(feedback.overigeInkomsten, gameState.language)}
                  unit={__('sim_globas')}
                  points={feedback.overigeInkomsten.winstverliesglobas}>
                  <div dangerouslySetInnerHTML={{ __html: getText(feedback.overigeInkomsten, gameState.language) }}/>
                </FeedbackEffect>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    );
  }

  getFeedbackEffectLaag = (oi, e, f) => {
    let icon,
      text,
      type,
      clickable;
    if (e) {
      clickable = true;
      icon = e.winstverliesglobas >= 0 ? icons.thumbsUp : icons.thumbsDown;
      text = e.winstverliesglobas >= 0
        ? __('sim_feedback_door_keuze_meer_globas')
        : __('sim_feedback_door_keuze_minder_globas');

      type = e.winstverliesglobas >= 0 ? 'profit' : 'loss'
    } else if (oi) {
      clickable = false;
      // OI is altijd positief
      icon = icons.thumbsUp;
      text = __('sim_feedback_keuze_extra_inkomsten');
    }

    const url = `/ministries/overview/${type}/${f.omschrijving}`;

    if (e || oi) {
      return <div className="feedback-laag-oi">
        <img src={icon} alt="thumbs" />
        <Link to={url} style={clickable ? {} : { pointerEvents: 'none' }}>
          <p dangerouslySetInnerHTML={{ __html: text }} />
        </Link>
      </div>;
    }
    return null;
  }

  renderLaag() {
    const { match, feedback: {prevRoundFeedbackData} } = this.props;
    const feedback = getFeedback(prevRoundFeedbackData, this.feedbackId);

    if(Object.entries(feedback).length === 0 && feedback.constructor === Object) {
      let url = "/ministries/" + (match.params.ministryId !== undefined ? match.params.ministryId : match.params.id);
      history.push(url);
      return null;
    }

    const overigEffect = feedback.overigeEffecten[this.effectId];
    const economie = feedback.economie;
    if (!economie) this.economie = false;
    if (!overigEffect) this.oe = false;
    // Check if OE
    if (this.oe || this.economie) feedback.type = 'OVERIGEFFECT'; // override type with OE
    if(!checkRead(feedback, this.oe, this.effectId, this.economie)) {
      if (this.oe) {
        feedback.read['readOe_' + this.effectId] = true;

        const array = feedback.read;

        array['readOe_' + this.effectId] = true;

        this.props.dispatch(updateRead(feedback.id, array));
      } else if (this.economie) {
        feedback.read.economie = true;

        const array = feedback.read;

        array.economie = true;

        this.props.dispatch(updateRead(feedback.id, array));
      } else {
        feedback.read.read = true;

        const array = feedback.read;

        this.props.dispatch(updateRead(feedback.id, array));
      }
    }

    return (
      <div>
        <div key="fbWrapper" className='container feedbackcontainer'>
          <GameTopBar
            match={{...match}}
            history={this.props.history}
            buttonType={'close'}
          />
          {this.renderMinistryHeader(feedback, overigEffect, economie)}
          {this.renderStatistics(feedback, overigEffect, economie)}
          {['ALGEMEEN', 'RAMP', 'STARTSITUATIE'].indexOf(feedback.type) !== -1 ? <FeedbackStatusRounds ministry={feedback.ministerie}/> : null}
          {this.renderFeedbackImage(feedback, overigEffect, economie)}
          {this.renderFeedbackText(feedback, overigEffect, economie)}
          {feedback.overigeInkomsten || feedback.economie ? (
            <div className={'effects-container laag'}>
              <div key="effectsHeader" className={'effects-header'}>
                <img src={icons.megafoon} alt="megafoon" />
                <span>{__('sim_let_op')}</span>
              </div>
              <FeedbackEffect minimal={true} difficulty="BASIC">
                {this.getFeedbackEffectLaag(feedback.overigeInkomsten, feedback.economie, feedback)}
              </FeedbackEffect>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default connect(({gameState, feedback, project, gameStateInput, schoolClass, policyChoice}) => ({gameState, feedback, project, gameStateInput, schoolClass, policyChoice}))(Feedback);



// WEBPACK FOOTER //
// ./src/components/routes/Feedback.js